import "./register.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { setToken } from "../../helpers/authHelpers";
import { useAuthContext } from "../../context/AuthContext";

export default function Register() {
  const navigate = useNavigate();
  const { setUser } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    const username = e.target.username.value;
    const email = e.target.email.value;
    const password = e.target.password.value;
    const secretword = e.target.secretword.value;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/local/register`,
        {
          username,
          email,
          password,
          secretword,
        }
      );

      const data = response.data;

      if (data?.error) {
        throw new Error(data.error.message);
      }

      // Save token
      setToken(data.jwt);

      // Save user to context
      setUser(data.user);

      // Navigate to profile page
      navigate("/profile", { replace: true });
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.error?.message || "Registration failed.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="register">
      <span className="registerTitle">Register</span>

      <form
        className="registerForm"
        onSubmit={handleRegister}
        autoComplete="off"
      >
        <label htmlFor="regFullname">Full Name</label>
        <input
          id="regFullname"
          name="fullname"
          className="registerInput"
          type="text"
          placeholder="Enter your full name..."
          required
        />

        <label htmlFor="regUsername">Username</label>
        <input
          id="regUsername"
          name="username"
          className="registerInput"
          type="text"
          placeholder="Enter your username..."
          required
        />

        <label htmlFor="regEmail">Email</label>
        <input
          id="regEmail"
          name="email"
          className="registerInput"
          type="email"
          placeholder="Enter your email..."
          required
        />

        <label htmlFor="regPassword">Password</label>
        <input
          id="regPassword"
          name="password"
          className="registerInput"
          type="password"
          placeholder="Enter your password..."
          required
        />

        <label htmlFor="secretword">Secret Word</label>
        <input
          id="secretword"
          name="secretword"
          className="registerInput"
          type="text"
          placeholder="Enter the Secret word..."
          required
        />

        {error && <p className="registerError">{error}</p>}

        <button className="registerButton" type="submit" disabled={isLoading}>
          {isLoading ? "Registering..." : "Register"}
        </button>
      </form>

      <button
        className="registerLoginButton"
        onClick={() => navigate("/login")}
      >
        Login
      </button>
    </div>
  );
}
